const WixConSteps = [
  {
    description: (
      <>
        <p>
          This Python library simplifies connecting to Wix Data's REST API with minimal setup and a Pythonic approach to form interaction. It leverages the requests library and offers high customizability.
          The library effectively manages data types, supporting a wide range with minimal formatting required.
        </p>
      </>
    ),
    badge: "Intro",
    image:
      "https://try-er.github.io/debasish/assets/images/experiment_images/wix-data.webp",
  },
  {
    description: (
      <>
        <p>
          Ex irure dolore veniam ex velit non aute nisi labore ipsum occaecat
          deserunt cupidatat aute. Enim cillum dolor et nulla sunt exercitation
          non voluptate qui aliquip esse tempor. Ullamco ut sunt consectetur
          sint qui qui do do qui do. Labore laborum culpa magna reprehenderit ea
          velit id esse adipisicing deserunt amet dolore. Ipsum occaecat veniam
          commodo proident aliqua id ad deserunt dolor aliquip duis veniam sunt.
        </p>
        <p>
          In dolore veniam excepteur eu est et sunt velit. Ipsum sint esse
          veniam fugiat esse qui sint ad sunt reprehenderit do qui proident
          reprehenderit. Laborum exercitation aliqua reprehenderit ea sint
          cillum ut mollit.
        </p>
      </>
    ),
    badge: "Development",
    description: (
      <>
        <p>  
          Development utilizes Pydantic for data validation and creation of robust data models. This abstraction simplifies most data operations, facilitated by intuitive connector and operator models. The library also handles advanced Wix data fields, such as rich content and rich text, ensuring seamless interaction.
        </p>
      </>
    )
  },
  {
    title: "Open for all to contribute !",
    description: (
      <>
        <p>
          The codebase that is under development can be accessed through following github repository. Feel free to contribute !  
        </p>
      </>
    ),
    badge: "Distribution",
    links: [
      {
        image: "https://try-er.github.io/debasish/assets/images/contact_logos/github_logo.webp",
        url: "https://github.com/TRY-ER/wix_connector.git",
        text: "TRY-ER/wix_connector",
      }
    ]
  }
];

export { WixConSteps };